import React, { useEffect, useState } from 'react';
import { Badge } from '@cloudscape-design/components';
import { apiFetch } from '../auth/apiClient';
import { openAppealWindow } from '../utils/appealWorkspace';
import './ActiveAppealBadge.css';

export default function ActiveAppealBadge({ caseId, applicationId }) {
  const [loaded, setLoaded] = useState(null);
  useEffect(() => {
    if (!caseId) return undefined;
    let active = true;
    let request = 0;
    const refresh = async event => {
      if (event?.detail?.caseId && String(event.detail.caseId) !== String(caseId)) return;
      const current = ++request;
      try {
        const response = await apiFetch(`/api/cases/${caseId}/appeals`);
        if (!response.ok) return;
        const appeals = await response.json();
        if (active && current === request && Array.isArray(appeals)) setLoaded({ caseId, appeals });
      } catch (_) { /* Keep the last known state; the existing quick action remains available. */ }
    };
    refresh();
    window.addEventListener('case-events-refresh', refresh);
    window.addEventListener('focus', refresh);
    return () => {
      active = false;
      window.removeEventListener('case-events-refresh', refresh);
      window.removeEventListener('focus', refresh);
    };
  }, [caseId]);

  const appeal = String(loaded?.caseId) === String(caseId) && loaded?.appeals.find(item =>
    ['pending', 'in_progress'].includes(item.status) &&
    (!applicationId || String(item.originalDecision?.applicationId) === String(applicationId) ||
      item.work?.some(work => String(work.applicationId) === String(applicationId)))
  );
  if (!appeal) return null;
  const label = appeal.status === 'pending' ? 'Appeal pending' : 'Appeal in progress';
  return (
    <button type="button" className="active-appeal-badge" aria-label={`${label} — view appeal`}
      onClick={() => openAppealWindow(caseId, appeal.id)}>
      <Badge color="blue">{label}</Badge>
    </button>
  );
}
